import { render } from "./HomeHC.vue?vue&type=template&id=48a585c4"
import script from "./HomeHC.vue?vue&type=script&lang=js"
export * from "./HomeHC.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__